import React, { useEffect, useRef, useState} from 'react';
import {Helmet} from "react-helmet";
import { useNavigate, useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {profileRequestLocal} from "../store/actions/users";
import {toast} from "react-toastify";
import Api from "../Api";
import Account from "../helpers/Account";
import {lang, login} from "../translate";
import Cookies from "js-cookie";
import img from '../assets/img/logo22.png'
import uc from '../assets/img/image_ucom.png'
const {REACT_APP_SERVER} = process.env;
import ats from '../assets/img/logo_light.png'
import { PROMOCODE_MODAL_DISMISSED_KEY } from '../components/new_component/PromocodeModal';

function Confirm(props) {
    const [password, setPassword] = useState('')
    const submittedRef = useRef(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()

    useEffect(() =>{
        if(REACT_APP_SERVER === 'ATS'){
            document.body.style.backgroundImage = 'none'
            if(document.getElementsByTagName('header')[0]){
                document.getElementsByTagName('header')[0].style.backgroundImage = 'none'
            }
            if(document.getElementsByTagName('footer')[0]){
                document.getElementsByTagName('footer')[0].style.backgroundImage = 'none'
            }
        }

    },[REACT_APP_SERVER])
    useEffect(() => {
        if (password.length !== 6 || submittedRef.current) return
        submittedRef.current = true
        ;(async () => {
            try {
                let newPhone = params.phone.replaceAll(' ','').replace('(','').replace(')','')
                if(params.type === 'employee'){
                    const {data} = await Api.confirmEmployee({username:newPhone, code:password, lang: lang[+localStorage.getItem('atsLang')],type:params.type})
                    Account.setAdminToken({access_token:data.access_token,refresh_token:data.refresh_token})
                    const cookieOpts = { expires: 30 }
                    Cookies.set('member', data.user.member, cookieOpts)
                    Cookies.set('key', data.key, cookieOpts)
                    Cookies.set('buddy', data.user.name, cookieOpts)
                    Cookies.set('new', true, cookieOpts)
                    navigate('/')
                }else{
                    const {data} = await Api.confirm({phone:newPhone, password, lang: lang[+localStorage.getItem('atsLang')],type:params.type})
                    if(params.type === 'user'){
                        await dispatch(profileRequestLocal(data))
                        Account.setAdminToken(data)
                        sessionStorage.removeItem(PROMOCODE_MODAL_DISMISSED_KEY);
                        navigate('/')
                    }else{
                        await dispatch(profileRequestLocal(data.user))
                        Account.setUrsAdminToken(data)
                        navigate('/urs')
                    }
                }
                Cookies.remove('login')
            } catch (e) {
                submittedRef.current = false
                toast.error(e.response?.data?.message || e.message);
                navigate('/login')
            }
        })()
    }, [password, params.phone, params.type, navigate, dispatch])

    const {REACT_APP_OPERATOR, REACT_APP_ATS} = process.env
    return (
        <>
            <Helmet>
                <title>{login.title[+localStorage.getItem('atsLang')]}</title>
            </Helmet>
            <div className="adminLogin flex-column">
                <section className="form_login_header">
                    {REACT_APP_SERVER === "ATS"?
                        <img style={{width: 110}} src={ats} alt=""/>
                        :<div style={REACT_APP_SERVER === "V-office" ||REACT_APP_SERVER === "Ucom"?{backgroundImage:"url("+uc+")"}:{backgroundImage:"url("+img+")",backgroundSize:100, backgroundPosition:'center'}} className="form_login_header_logo"/>}
                    <div style={REACT_APP_SERVER === "ATS"?{color:'#00AB64'}:{}} className="form_login_header_info">
                        Virtual ATS
                    </div>
                </section>
                <div className="confirmContainer">
                    <div className="adminLoginPage">

                        <form className="adminLoginForm">
                            <div className="adminLoginMain">
                                <label htmlFor="adminPass" style={{display: 'flex'}} className="adminFormLabel">
                                    <input
                                        autoFocus={true}
                                        id="adminPass"
                                        value={password}
                                        onChange={(ev) => setPassword(ev.target.value)}
                                    />
                                    <span className="count_pass">{password.length} / 6</span>
                                </label>
                            </div>
                        </form>

                        <div className="confirmCodeHintBlock">
                            <p
                                className="confirm-code-hint"
                                style={{
                                    marginTop: 16,
                                    marginBottom: 0,
                                    fontSize: 12,
                                    lineHeight: 1.45,
                                    color: 'rgba(0, 0, 0, 0.65)',
                                    maxWidth: 360,
                                }}
                            >
                                *{login.confirmCodeHint[+localStorage.getItem('atsLang') || 1]}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default Confirm;
